import { useQuery } from 'react-query';
import BeaconsApi from './beacons.api';

export const useGetNewBeacons = (token: string, source: string) => {
  const beaconsApi = new BeaconsApi(token);

  return useQuery('new-beacons', () => beaconsApi.getUnregisteredBeacons(), {
    staleTime: Infinity,
    refetchOnMount: 'always',
    enabled: source !== '',
    cacheTime: 0,
    retry: false,
  });
};

export const useGetRegisteredBeacons = (
  token: string,
  nextToken: string | null,
  sortParam: string,
  sortDirection: string,
) => {
  const beaconsApi = new BeaconsApi(token);

  return useQuery(
    'registered-beacons',
    () => beaconsApi.getLocalizedBeacons(null, nextToken, sortParam, sortDirection),
    {
      staleTime: Infinity,
      retry: false,
      refetchOnMount: 'always',
      cacheTime: 0,
    },
  );
};
